import { usePage, useWebsiteSettings } from 'client/store'
import { pageSelectors } from 'client/store/page/pageSelectors'
import { AlignType } from 'common/types/styleTypes'
import { getWebsiteStylesTypographyParagraph } from 'src/editor/store/website-settings/website-settings-selector'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'
import { typographySelectorMap } from 'src/editor/store/website-settings/website-settings-selector'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'

export const useTextAlign = ({
  textAlign,
  mobileTextAlign,
  typographyType = WebsiteSettingsTypographyTypeEnum.Paragraph,
}: {
  textAlign?: AlignType
  mobileTextAlign?: AlignType
  typographyType?: WebsiteSettingsTypographyTypeEnum
}) => {
  const pageGlobalTextAlign = usePage(pageSelectors.getGlobalTextAlign)
  const pageGlobalMobileTextAlign = usePage(
    pageSelectors.getGlobalMobileTextAlign,
  )

  const globalTextAlignOrEmpty =
    typographyType === WebsiteSettingsTypographyTypeEnum.FormField
      ? undefined
      : pageGlobalTextAlign

  const globalMobileTextAlignOrEmpty =
    typographyType === WebsiteSettingsTypographyTypeEnum.FormField
      ? undefined
      : pageGlobalMobileTextAlign

  const typographySelector = typographySelectorMap[typographyType]

  const {
    textAlign: websiteGlobalTextAlign,
    mobileTextAlign: websiteGlobalMobileTextAlign,
  } = useWebsiteSettings(typographySelector) || {}

  const globalTextAlign = globalTextAlignOrEmpty || websiteGlobalTextAlign
  const globalMobileTextAlign =
    globalMobileTextAlignOrEmpty || websiteGlobalMobileTextAlign

  return {
    calculatedTextAlign: getCalculatedProperty({
      desktopProperty: textAlign,
      mobileProperty: mobileTextAlign,
      globalDesktopProperty: globalTextAlign,
      globalMobileProperty: globalMobileTextAlign,
    }) as { mobile: AlignType; desktop: AlignType },
    globalTextAlign,
    globalMobileTextAlign,
  }
}
